import { Button } from "antd";
import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

type RegisterCardProps = {
  title: string;
  icon: ReactNode;
  href: string;
};

const RegisterCard: React.FC<RegisterCardProps> = ({ title, icon, href }) => {
  const navigate = useNavigate();
  return (
    <div className="group flex h-full min-h-[320px] w-full flex-col rounded-3xl border-2 border-gray-100 bg-gradient-to-b from-white to-gray-50/90 p-6 sm:p-7 md:min-h-[340px] lg:min-h-[360px] shadow-md transition-all duration-300 hover:border-green-200/90 hover:shadow-lg">
      <div className="mx-auto flex h-[128px] w-[128px] shrink-0 items-center justify-center rounded-3xl bg-amber-50 ring-2 ring-amber-100/90 transition-transform duration-300 group-hover:scale-[1.02] group-hover:ring-green-200/80 lg:h-[140px] lg:w-[140px]">
        {icon}
      </div>
      <h3 className="mt-5 flex-1 text-center text-lg font-bold leading-snug text-gray-900 lg:text-xl">
        {title}
      </h3>
      <Button
        type="primary"
        block
        size="large"
        onClick={() => navigate(href)}
        className="mt-6 h-auto min-h-[52px] border-none !bg-green-600 px-5 py-3 !text-lg font-semibold shadow-sm hover:!bg-green-700"
      >
        Subscribe
      </Button>
    </div>
  );
};

export default RegisterCard;
